import IMask from "imask";

const masks = new Map();

document.addEventListener("turbo:load", () => {
  const phones = document.querySelectorAll("[data-phone]");
  const phoneMask = "+{7} (000) 000-00-00";
  
  [].forEach.call(phones, (phone) => {
    if (masks.has(phone)) return;

    const maskOptions = {
      mask: phoneMask,
      lazy: false,
    };
    masks.set(phone, IMask(phone, maskOptions));
  });
});

document.addEventListener("turbo:before-cache", () => {
  masks.forEach((mask) => mask.destroy());
  masks.clear();
});
